<div class="container waitlist-other black-link">
    <div class="row">
        <img
            src="/assets/images/octopus-logo-white.png"
            alt="Welcome"
            class="welcome-img mx-auto"
        />
    </div>
    <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12 text-center mb-4">
            <p class="my-4">
                Thank you for your interest in joining Play Octopus.
            </p>
            <div class="col-md-12 col-lg-12 col-sm-12 text-center">
                <img
                    src="/assets/images/us-wide-launch.png"
                    alt="All 50 U.S. States"
                    height="100%"
                    width="100%"
                />
            </div>
            <span class="bold-text">Current markets</span>: <br />
            <p class="my-4">
                We are now shipping to all 50 U.S. states. If you are located in
                one of these supported areas, please email
                <a href="mailto:contact&#64;playoctopus.com" id="waitlist-other-contact-email">
                    <span class="bold-text">contact&#64;playoctopus.com</span></a
                >
                to continue with your application.
            </p>
        </div>
    </div>
</div>
